<div mat-dialog-content>
    <div class="files-container-button">
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>  
    <p class="title">Documentacion</p>
    <div class="cov-container-files">
        <p class="title" >Archivos</p>
        <div *ngIf="loadingDay" class="cov-container-loader">
            <div class="cov-loader"></div>
        </div>
        <div *ngIf="!loadingDay" class="cov-content-files">
            <div *ngFor="let f of fileListStart" class="cov-card-files" matTooltip="{{f.name}}" matTooltipPosition="above"
                matTooltipClass="tooltip">
                <p>{{f.type}}</p>
                <button mat-icon-button matTooltip="Descargar" matTooltipPosition="below" matTooltipClass="tooltip"
                        (click)="download(f)">
                        <mat-icon class="blue-color">cloud_download</mat-icon>
                    </button>
            </div>
        </div>
    </div>
</div>